const sectionGuaranteedSafeCheckoutCss = `
[data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] {
  padding-top: var(--padding-top-desktop, 0);
  padding-bottom: var(--padding-bottom-desktop, 0);
}

[data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] .image {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
  margin: 0 auto;
}

[data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] .image img {
  max-width: 100%;
  height: auto;
  display: block;
}

[data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] figure {
  overflow-x: auto;
  overflow-y: hidden;
}

[data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] h1,
[data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] h2,
[data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 6px 0 !important;
}

[data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] h1:last-child,
[data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] h2:last-child,
[data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] p {
  font-size: 14px;
  line-height: normal;
  margin: 0 0 4px 0 !important;
}

[data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] p:last-child {
  margin-bottom: 0 !important;
}

@container (max-width: 768px) {
  [data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] {
    padding-top: var(--padding-top-mobile, 0);
    padding-bottom: var(--padding-bottom-mobile, 0);
  }

  [data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] figure {
    width: 98% !important;
  }

  [data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] h1,
  [data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] h2,
  [data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] h3 {
    font-size: 20px;
  }

  [data-type='section-guaranteed-safe-checkout'] [data-attribute='content'] p {
    font-size: 12px;
  }
}
`;
export default sectionGuaranteedSafeCheckoutCss;
